import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "absolute z-1 bottom-0 left-0 mx-auto right-0 text-center w-2/3 pb-30 md:pb-70 lg:w-1/2" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 2,
  class: "mb-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CMSLinkHandler = _resolveComponent("CMSLinkHandler")!
  const _component_MediaHandler = _resolveComponent("MediaHandler")!

  return (_openBlock(), _createElementBlock("section", {
    class: "relative",
    style: _normalizeStyle('color:' + _ctx.content.textColor)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.mediaTileContentBlock.subheading)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "o-text-caption uppercase m-0",
            innerHTML: _ctx.mediaTileContentBlock.subheading
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      (_ctx.mediaTileContentBlock.title)
        ? (_openBlock(), _createElementBlock("h2", {
            key: 1,
            class: "mb-10",
            innerHTML: _ctx.mediaTileContentBlock.title
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      (_ctx.mediaTileContentBlock.text)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.mediaTileContentBlock.text), 1))
        : _createCommentVNode("", true),
      (_ctx.mediaTileContentBlock.link)
        ? (_openBlock(), _createBlock(_component_CMSLinkHandler, {
            key: 3,
            class: "mt-15",
            "link-block": _ctx.mediaTileContentBlock.link,
            "style-as-button": !_ctx.content.alternativeLinkStyle
          }, null, 8, ["link-block", "style-as-button"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_MediaHandler, {
      "video-disable-on-mobile": _ctx.content.disableVideoOnMobile,
      "media-aspect-ratio": _ctx.aspectRatio,
      "media-block": _ctx.mediaTileContentBlock.media
    }, null, 8, ["video-disable-on-mobile", "media-aspect-ratio", "media-block"])
  ], 4))
}